import {_} from "../utils";

export default class LanguageSwitcher {

    private readonly LANGUAGE_SWITCHER_SELECTOR = _('language-switcher', 'element').node() as HTMLElement | null;
    private readonly DROPDOWN_ELEMENTS = this.LANGUAGE_SWITCHER_SELECTOR?.querySelectorAll('.dropdown__item');
    private readonly LANGPATH = this.LANGUAGE_SWITCHER_SELECTOR?.dataset.langPath;

    init() {
        this.removeUsaFromScalextric()
    }

    removeUsaFromScalextric() {
        if (!this.DROPDOWN_ELEMENTS?.length) {
            return;
        }

        if (this.LANGPATH === 'scalextric-uk') {
            this.DROPDOWN_ELEMENTS.forEach(element => {
               let link = element.querySelector('a');
               if (link?.innerHTML.includes("Hornby Hobbies USA")){
                     element.remove()
               }
            });
        }
    }
}

const loader = new LanguageSwitcher();
loader.init()